import React from 'react';
import P from 'prop-types';

import { Box } from '@nerdwallet/currency';
import classNames from 'classnames';

import '../flex-card.less';
import UniversalContainer from '../../universal-container/universal-container';
import UniversalText from '../../universal-text/universal-text';
import UniversalImage from '../../universal-image/universal-image';
import UniversalButton from '../../universal-button/universal-button';

const FlexCardItem = ({
  desktopCarousel,
  maxWidthTwoThirds,

  // V2 Props
  cardBackgroundColor,
  eyebrow,
  title,
  subtitle,
  bodyCopy,
  cardImage,
  cardLabel,
  cardButton,
}) => {
  return (
    <UniversalContainer {...cardBackgroundColor}>
      <Box
        padding="2"
        className={classNames('flex-card-item', {
          carousel: desktopCarousel,
        })}
      >
        <UniversalImage {...cardImage} />
        <Box
          className={classNames('flex-card-content', [
            {
              maxWidthTwoThirdsSpaces: maxWidthTwoThirds,
            },
          ])}
        >
          <UniversalText
            {...eyebrow}
            defaultOptions={{ text: { textType: 'accent' } }}
          />
          <UniversalText {...title} />
          <UniversalText
            {...subtitle}
            defaultOptions={{ text: { textType: 'text' } }}
          />
          <UniversalText
            {...bodyCopy}
            defaultOptions={{ text: { textType: 'text' } }}
          />
          <UniversalText
            {...cardLabel}
            defaultOptions={{ text: { textType: 'text' } }}
          />
          <UniversalButton {...cardButton} />
        </Box>
      </Box>
    </UniversalContainer>
  );
};

FlexCardItem.displayName = 'FlexCardItem';

FlexCardItem.propTypes = {
  desktopCarousel: P.bool,
  maxWidthTwoThirds: P.bool,

  // V2 Props
  cardBackgroundColor: P.object,
  eyebrow: P.object,
  title: P.object,
  subtitle: P.object,
  bodyCopy: P.object,
  cardImage: P.object,
  cardLabel: P.object,
  cardButton: P.object,
};

FlexCardItem.defaultProps = {
  desktopCarousel: false,
  maxWidthTwoThirds: false,

  // V2 Props
  cardBackgroundColor: {},
  eyebrow: {},
  title: {},
  subtitle: {},
  bodyCopy: {},
  cardImage: {},
  cardLabel: {},
  cardButton: {},
};

export default React.memo(FlexCardItem);
